// External Imports
import { useState } from "react";
import Modal from "../UI/Modal";
import Heading from "../UI/Heading";
import { MdClose } from "react-icons/md";
import DetailPair from "../UI/DetailPair";
import SelectPair from "../UI/SelectPair";
import { requestAdminAPI } from "../../api/posh-api";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";

// Internal Imports

/** ========================================================================
 * * MarkAsPaidModal Component
 * This component renders a form to charge an invoice.
 * ========================================================================== */

export default function MarkAsPaidModal({
  open,
  setOpen,
  invoice,
  onComplete,
}) {
  const [otherType, setOtherType] = useState(false);
  const [loading, setLoading] = useState(false);

  /* ====================== MARK AS PAID  ====================== */
  const submitHandler = async () => {
    try {
      setLoading(true);
      await requestAdminAPI("mark-paid", {
        paymentId: invoice.id,
        paidVia: otherType
          ? document.getElementById("paymentMethodDescription").value
          : document.getElementById("paidVia").value,
        code: document.getElementById("code").value,
      });
      onComplete && onComplete();
      setOpen(false);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  if (!invoice) return null;
  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal">
        <Heading title="Mark Invoice as Paid" id={invoice?.id}>
          <MdClose onClick={() => setOpen(false)} className="icon" />
        </Heading>
        <div className="info lg:grid-cols-3">
          <DetailPair
            label="Customer"
            value={`${invoice.customer?.firstName} ${invoice.customer?.lastName}`}
          />
          <DetailPair
            label="Booking"
            value={
              invoice.booking
                ? `${invoice.booking?.vehicle.year} ${invoice.booking?.vehicle?.make?.name} ${invoice.booking?.vehicle?.model}`
                : "-"
            }
          />
          <DetailPair label="Category" value={invoice.category} />
          <div className="lg:col-span-3">
            <DetailPair
              label="Description"
              classes="font-semibold text-stone-200 text-base"
              value={invoice.description}
            />
          </div>
          <DetailPair label="Subtotal" value={`$${invoice.subtotal}`} />
          <DetailPair label="Taxes" value={`$${invoice.taxes}`} />
          <DetailPair
            label="Total"
            classes="font-semibold text-xl"
            value={`$${invoice.amount}`}
          />

          <SelectPair
            label="Payment Method"
            options={[
              { id: "_cash", name: "Cash" },
              { id: "_clover", name: "Clover POS" },
              { id: "_zelle", name: "Direct Transfer to POSH" },
            ]}
            edit={true}
            inputOptions={{
              id: "paidVia",
              defaultValue: "_cash",
              onChange: (e) =>
                e.target.value === "other"
                  ? setOtherType(true)
                  : setOtherType(false),
            }}
          />
          {otherType && (
            <div className="lg:col-span-2">
              <DetailPair
                label="Payment Method Description"
                edit={true}
                inputOptions={{
                  id: "paymentMethodDescription",
                  required: otherType,
                  placeholder:
                    "Describe how the payment was received and by whom...",
                }}
              />
            </div>
          )}
          <DetailPair
            label="Discount Code"
            edit={true}
            inputOptions={{
              type: "text",
              id: "code",
              placeholder: "optional",
            }}
          />
        </div>
        {loading ? (
          <LoadingSpinnerWrapper />
        ) : (
          <div className="grid-cols-2 info">
            <div onClick={() => setOpen(false)} className="btn-secondary">
              Cancel
            </div>
            <button onClick={submitHandler} className="btn-primary">
              Mark as Paid
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
}
